import { Constants } from './device';
export default Constants;
